<template>
  <div class="bg position-relative">
    <div class="bc">

      <div class="top_space"/>
      <img class="img_1" loading="lazy" alt="加盟優勢">

      <div class="img_space"/>
      <Glide :glide-item-type="glideItemType" :htmlArray="htmlArray"/>

      <div class="glide_space"/>

      <div class="row no-gutters button_area" :class="showJoin ?'':'hide'">
        <button type="button" class="btn btn-outline-primary button_style" @click="clickJoin">
          <div class="row no-gutters justify-content-center align-items-center">
            <span class="button_text">
              我要加盟
            </span>
            <div class="button_space"/>
            <img class="button_icon" src="/img/image/icon/arrow-2.png" loading="lazy" alt>
          </div>
        </button>
      </div>
      <div class="down_space"/>
    </div>
  </div>
</template>

<script>
import * as GlideItemType from '../../shared/glide_item_type'
import Glide from "../../components/Glide";
import GlideItem from "../../components/GlideItem/GlideItem";

export default {
  name: "Stage_6",
  components: {Glide},
  computed: {
    glideItemType() {
      return GlideItemType.join;
    },
  },
  data() {
    return {
      htmlArray: [
        {
          title: "區域保障",
          pointList: [
            "保障門市營運利益",
            "不惡意擴張",
            "避免網內互打",
            "商圈保障範圍",
            "絕不開設第二家",
          ],
        },
        {
          title: "加盟主肯定",
          pointList: [
            "業績穩定",
            "專業指導",
            "永續經營成長",
          ],
        },
        {
          title: "行銷活動",
          pointList: [
            "總部協助各店行銷曝光",
            "定期多元企劃活動",
            "開幕行銷協助",
            "持續研發多元新商品",
          ],
        },
        {
          title: "教育訓練",
          pointList: [
            "詳盡開店流程教學",
            "原物料進存貨管理",
            "顧客開發&管理",
          ],
        },
        {
          title: "實賺實拿",
          pointList: [
            "加盟無隱形費用",
            "實賺實拿無抽成",
            "加盟金已含所有器具、器材、設備、立牌、招牌費用",
          ],
        },
      ]
    };
  },
  props: {
    showJoin: Boolean,
    default: true,
  },
  methods: {
    clickJoin() {
    },
  },
}
</script>

<style lang="scss" scoped>


.bg {
  background-image: url('/img/image/background/bg_s6.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}


.top_space {
  height: 50px;
}

@media (max-width: 576px) {
  .top_space {
    height: 75px;
  }
}

@media (max-width: 360px) {
  .top_space {
    height: 55px;
  }
}


.img_space {
  height: 50px;
}

@media (max-width: 576px) {
  .img_space {
    height: 55px;
  }
}

@media (max-width: 360px) {
  .img_space {
    height: 36px;
  }
}


// 文字 加盟優勢
.img_1 {
  max-width: 676px;
  width: 676px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
  content: url('/img/image/home/t_10_1.png');
}

@media (max-width: 1440px) {
  .img_1 {
    margin-left: 300px;
  }
}

@media (max-width: 992px) {
  .img_1 {
    margin: 0;
    width: 47vw;
  }
}

@media (max-width: 576px) {
  .img_1 {
    width: 58vw;
  }
}

@media (max-width: 360px) {
  .img_1 {
    width: 155px;
    content: url('/img/image/home/t_10_2.png');
  }
}

// 圖片 圈圈
.img_2 {
  position: absolute;
  top: 40px;
  margin-left: 20px;
  width: 352px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

.glide_space {
  height: 65px;
}

.button_area {
  padding-right: 13.75rem !important;
  padding-left: 13.75rem !important;
}

@media (max-width: 992px) {
  .button_area {
    padding-top: 60px;
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
}

@media (max-width: 576px) {
  .button_area {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}


.button_style {
  width: 100%;
  height: 90px;
  border-radius: 10px;
  border: 2px solid #D56835;
  background-color: transparent;
  color: #D56835;
}

@media (max-width: 576px) {
  .button_style {
    height: 45px;
    padding: 0;
  }
}

.button_style:active {
  background-color: transparent !important;
  color: #D56835;
}

.button_style:focus {
  background-color: transparent !important;
  color: #D56835;
}

.button_style:hover {
  background-color: transparent !important;
  color: #D56835;
}

.button_space {
  width: 16px;
}

@media (max-width: 576px) {
  .button_space {
    width: 0;
    height: 0;
  }
}


.button_text {
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
  color: #D56835;
}

@media (max-width: 576px) {
  .button_text {
    font-size: 24px;
  }
}

@media (max-width: 360px) {
  .button_text {
    font-size: 18px;
  }
}


.button_space {
  width: 16px;
}

@media (max-width: 576px) {
  .button_space {
    width: 0;
    height: 0;
  }
}

.button_icon {
  width: 48px;
  height: 48px
}

@media (max-width: 576px) {
  .button_icon {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}

.down_space {
  height: 35px;
}

.hide {
  visibility: hidden;
  display: none;
  height: 0;
  width: 0;
}

</style>
